
import { Shield, Lock, Users, ArrowRight } from "lucide-react";
import { ContactButton } from "@/components/ui/button";
import { Container } from "@/components/ui/container";

interface ServiceCardProps {
  icon: React.ElementType;
  title: string;
  description: string;
  modalTitle?: string;
  modalDescription?: string;
}

const ServiceCard = ({ icon: Icon, title, description, modalTitle, modalDescription }: ServiceCardProps) => {
  return (
    <div className="p-6 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300">
      <Icon className="h-12 w-12 text-edgefi-purple mb-4" aria-hidden="true" />
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <ContactButton 
        variant="outline" 
        className="w-full group"
        modalTitle={modalTitle}
        modalDescription={modalDescription}
      >
        Learn More 
        <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" />
      </ContactButton>
    </div>
  );
};

export const ServiceCards = () => {
  const services = [
    {
      icon: Shield,
      title: "Security Assessment",
      description: "Comprehensive evaluation of your M365 environment to identify security gaps and optimization opportunities.",
      modalTitle: "M365 Security Assessment",
      modalDescription: "Our security assessment provides a comprehensive evaluation of your Microsoft 365 environment. Fill out the form below to learn more about our approach."
    },
    {
      icon: Lock,
      title: "Implementation Support",
      description: "Expert guidance and hands-on support to implement Microsoft-recommended security controls.",
      modalTitle: "M365 Implementation Support",
      modalDescription: "Get expert guidance and hands-on support to implement Microsoft-recommended security controls. Contact us to learn more."
    },
    {
      icon: Users,
      title: "Training & Education",
      description: "Empower your team with security awareness training and best practices for M365 security.",
      modalTitle: "M365 Security Training",
      modalDescription: "Empower your team with security awareness training and best practices for Microsoft 365 security. Fill out the form to discuss your training needs."
    }
  ];

  return (
    <section className="py-16" id="services">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard 
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              modalTitle={service.modalTitle}
              modalDescription={service.modalDescription}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};
